// @ts-nocheck
import { useQuery }               from '@apollo/client'
import { ArrowUturnLeftIcon }     from '@heroicons/react/24/solid'
import { useState }               from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button }                 from '../../../components'
import { LoadingEllipsis }        from '../../../components/Loaders/Loaders'
import { GET_DOCUMENT_BY_ID }     from '../../../graphql/document'
import FileForm                   from './FileForm'

export default function EditFile() {
  const { page, unique_id }       = useParams()
  const [ document, setDocument ] = useState( null )
  const navigate: any             = useNavigate()
  const { loading, error }        = useQuery( GET_DOCUMENT_BY_ID, {
    variables:   { input: { unique_id } },
    onCompleted: ( { documentByUid } ) => setDocument( documentByUid ),
    onError:     ( error: any ): void => console.log( error )
  } )

  return (
    <div>
      { loading && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }
      { !loading && document &&
        <>
          <div className="w-24 my-4">
            <Button
              label="Back"
              blue
              onClick={ (): any => navigate( -1 ) }
              icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
            />
          </div>

          <h4 className="font-medium text-xl">
            Edit Document
          </h4>

          <FileForm document={ document } parentId={ unique_id } page={ page ?? 1 }></FileForm>
        </>
      }
      {
        error &&
        <div className="flex flex-col">
          <b>Error occurred when fetching documents:</b> { ' ' }
          { error.graphQLErrors.map( ( { message }, i: number ) => (
            <span key={ i }>{ message }</span>
          ) ) }
        </div>
      }
    </div>
  )
}
